import React from 'react';
import {
    BRAND_LIBRARY_BUTTON_HOVER_COLOR,
    BRAND_LIBRARY_LIGHT_TEXT_COLOR,
    BRAND_LIBRARY_BUTTON_TEXT,
} from 'common/constants/brandLibrary';

import Link from 'common/components/TouchpointEditor/components/TouchpointNodes/Link';

export default function ViewAgendaLink(props) {
    return <Link {...props} />;
}

ViewAgendaLink.splash = {
    ...Link.splash,
    defaultProps: {
        ...Link.splash.defaultProps,
        meta: {
            ...Link.splash.defaultProps.meta,
            content: 'View the Agenda',
            href: '#viewAgenda',
        },
        styles: {
            ...Link.splash.defaultProps.styles,
            fontColor: BRAND_LIBRARY_LIGHT_TEXT_COLOR,
            fontColorHover: BRAND_LIBRARY_BUTTON_HOVER_COLOR,
            fontSize: 16,
            fontFamily: BRAND_LIBRARY_BUTTON_TEXT,
        },
    },
};
